import React from "react";
import { ChevronDownIcon } from "../../../Icons";
import { LIBRARY_STATUS_PILL } from "../librariesTheme";

/**
 * Compact inline status select for catalog table rows.
 * Sized to match Edit/Delete row actions — not a large pill.
 */
const LibraryStatusSelect = ({
  value = "Inactive",
  disabled = false,
  onChange,
  id,
}) => {
  const status = value === "Active" ? "Active" : "Inactive";
  const tone = LIBRARY_STATUS_PILL[status] || LIBRARY_STATUS_PILL.Inactive;

  return (
    <div className="relative inline-flex w-[5.75rem] align-middle">
      <select
        id={id}
        value={status}
        disabled={disabled}
        aria-label="Change status"
        onChange={(e) => {
          const next = e.target.value;
          if (next === status) return;
          onChange?.(next);
        }}
        className={`appearance-none w-full h-5 pl-1.5 pr-5 text-[10px] leading-none font-semibold rounded border outline-none cursor-pointer transition-colors disabled:opacity-60 disabled:cursor-not-allowed focus:ring-1 focus:ring-indigo-100 focus:border-indigo-300 ${tone}`}
      >
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
      </select>
      <ChevronDownIcon
        size={10}
        className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 text-current opacity-60"
        aria-hidden
      />
    </div>
  );
};

export default LibraryStatusSelect;
